import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { List, Plus, Trash2 } from 'lucide-react';

const PaymentMethodManager = ({ paymentMethods, onAddPaymentMethod, onRemovePaymentMethod }) => {
  const [newPaymentMethod, setNewPaymentMethod] = useState('');

  const handleAdd = () => {
    if (newPaymentMethod.trim()) {
      onAddPaymentMethod({ name: newPaymentMethod.trim() });
      setNewPaymentMethod('');
    }
  };

  return (
    <Card className="glass-effect border-white/20">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <List className="w-5 h-5" />
          Gerenciar Formas de Pagamento
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2 mb-4">
          <Input
            placeholder="Nova forma de pagamento..."
            value={newPaymentMethod}
            onChange={(e) => setNewPaymentMethod(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
            className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
          />
          <Button onClick={handleAdd} className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700">
            <Plus className="w-4 h-4" />
          </Button>
        </div>
        <div className="space-y-2 max-h-60 overflow-y-auto pr-2">
          {paymentMethods.length === 0 ? (
            <p className="text-white/70 text-center py-4">Nenhuma forma de pagamento cadastrada.</p>
          ) : (
            paymentMethods.map((method) => (
              <div
                key={method.id}
                className="flex justify-between items-center p-2 bg-white/5 rounded-md"
              >
                <span className="text-white">{method.name}</span>
                <Button size="sm" variant="ghost" onClick={() => onRemovePaymentMethod(method.id)} className="text-red-400 hover:text-red-300 hover:bg-red-500/20">
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentMethodManager;